import SiteEnv from '../utils/siteEnv';


export const ApiPath = SiteEnv.showApiPath();
export const SchoolApiPath = SiteEnv.showSchoolApiPath();




// WEBPACK FOOTER //
// ./src/fetch/config.js